import React, { useState } from 'react';
import QuickMenu from '../../components/QuickMenu/QuickMenu';
import './PersonalInformationRequest.scss';

const API_URL = process.env.REACT_APP_API_URL;

const PersonalInformationRequest = () => {
  const [formData, setFormData] = useState({
    tcKimlik: '',
    dogumTarihi: {
      gun: '',
      ay: '',
      yil: ''
    },
    ad: '',
    soyad: '',
    telefon: '',
    email: '',
    cevapYontemi: [],
    basvuruTipi: '',
    il: '',
    ilce: '',
    disKapiNo: '',
    icKapiNo: '',
    dosya: null,
    basvuruMetni: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateTcKimlik = (value) => {
    return value.replace(/[^0-9]/g, '').slice(0, 11);
  };

  const validatePhone = (value) => {
    return value.replace(/[^0-9\s\-\(\)]/g, '').slice(0, 15);
  };

  const validateName = (value) => {
    return value.replace(/[^a-zA-ZçğıöşüÇĞIİÖŞÜ\s]/g, '').slice(0, 50);
  };

  const validateEmail = (value) => {
    return value.toLowerCase().slice(0, 100);
  };

  const validateDoorNumber = (value) => {
    return value.replace(/[^a-zA-Z0-9çğıöşüÇĞIİÖŞÜ]/g, '').slice(0, 10);
  };

  const validateDatePart = (value, type) => {
    let numericValue = value.replace(/[^0-9]/g, '');
    
    if (type === 'day') {
      numericValue = numericValue.slice(0, 2);
      if (parseInt(numericValue) > 31) numericValue = '31';
    } else if (type === 'month') {
      numericValue = numericValue.slice(0, 2);
      if (parseInt(numericValue) > 12) numericValue = '12';
    } else if (type === 'year') {
      numericValue = numericValue.slice(0, 4);
      const currentYear = new Date().getFullYear();
      if (parseInt(numericValue) > currentYear) numericValue = currentYear.toString();
    }
    
    return numericValue;
  };

  const validateTextarea = (value, maxLength = 2000) => {
    return value.slice(0, maxLength);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.tcKimlik) {
      newErrors.tcKimlik = 'T.C. Kimlik Numarası zorunludur.';
    } else if (formData.tcKimlik.length !== 11) {
      newErrors.tcKimlik = 'T.C. Kimlik Numarası 11 haneli olmalıdır.';
    }

    const { gun, ay, yil } = formData.dogumTarihi;
    if (!gun || !ay || !yil) {
      newErrors.dogumTarihi = 'Doğum tarihi tam olarak girilmelidir.';
    } else if (gun.length < 1 || ay.length < 1 || yil.length !== 4) {
      newErrors.dogumTarihi = 'Doğum tarihi geçerli formatta girilmelidir.';
    } else {
      const day = parseInt(gun);
      const month = parseInt(ay);
      const year = parseInt(yil);
      const date = new Date(year, month - 1, day);
      
      if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
        newErrors.dogumTarihi = 'Geçersiz tarih girdiniz.';
      } else if (date > new Date()) {
        newErrors.dogumTarihi = 'Doğum tarihi gelecek bir tarih olamaz.';
      }
    }

    if (!formData.ad.trim()) {
      newErrors.ad = 'Ad alanı zorunludur.';
    } else if (formData.ad.trim().length < 2) {
      newErrors.ad = 'Ad en az 2 karakter olmalıdır.';
    }

    if (!formData.soyad.trim()) {
      newErrors.soyad = 'Soyad alanı zorunludur.';
    } else if (formData.soyad.trim().length < 2) {
      newErrors.soyad = 'Soyad en az 2 karakter olmalıdır.';
    }

    if (!formData.telefon.trim()) {
      newErrors.telefon = 'Telefon numarası zorunludur.';
    } else if (formData.telefon.replace(/[^0-9]/g, '').length < 10) {
      newErrors.telefon = 'Geçerli bir telefon numarası girin.';
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email.trim()) {
      newErrors.email = 'E-posta adresi zorunludur.';
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = 'Geçerli bir e-posta adresi girin.';
    }

    if (!formData.basvuruTipi) {
      newErrors.basvuruTipi = 'Başvuru tipi seçimi zorunludur.';
    }

    if (!formData.basvuruMetni.trim()) {
      newErrors.basvuruMetni = 'Başvuru metni zorunludur.';
    } else if (formData.basvuruMetni.trim().length < 10) {
      newErrors.basvuruMetni = 'Başvuru metni en az 10 karakter olmalıdır.';
    }

    if (formData.cevapYontemi.length === 0) {
      newErrors.cevapYontemi = 'En az bir cevap yöntemi seçmelisiniz.';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    if (!validateForm()) {
      return;
    }

    const [g, a, y] = [
      formData.dogumTarihi.gun,
      formData.dogumTarihi.ay,
      formData.dogumTarihi.yil
    ].map(Number);
    const birthDate = (g && a && y) ? new Date(y, a - 1, g).toISOString() : null;

    const payload = {
      type: "sahis",
      tckn: formData.tcKimlik,
      name: formData.ad.trim(),
      surName: formData.soyad.trim(),
      birthDate,
      gsmNo: formData.telefon.trim(),
      eMail: formData.email.trim(),
      address: [formData.il, formData.ilce, `Dış Kapı: ${formData.disKapiNo}`, `İç Kapı: ${formData.icKapiNo}`].filter(Boolean).join(' - '),
      responseType: formData.cevapYontemi.join(','),
      file: null,
      requestType: formData.basvuruTipi,
      requestNote: formData.basvuruMetni.trim()
    };

    try {
      setIsSubmitting(true);
      const res = await fetch(`${API_URL}/InformationForm/PostInformationForm`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      if (!res.ok || !data?.isSuccess) throw new Error(data?.resultMessage || 'Hata');
      
      alert('Başvurunuz alındı.');
      
      setFormData({
        tcKimlik: '',
        dogumTarihi: { gun: '', ay: '', yil: '' },
        ad: '',
        soyad: '',
        telefon: '',
        email: '',
        cevapYontemi: [],
        basvuruTipi: '',
        il: '',
        ilce: '',
        disKapiNo: '',
        icKapiNo: '',
        dosya: null,
        basvuruMetni: ''
      });
      setErrors({});
      
    } catch (err) {
      alert('Gönderim sırasında hata oluştu: ' + err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
    
    if (type === 'checkbox') {
      const newCevapYontemi = checked 
        ? [...formData.cevapYontemi, value]
        : formData.cevapYontemi.filter(item => item !== value);
      
      setFormData(prev => ({
        ...prev,
        cevapYontemi: newCevapYontemi
      }));
      
      if (errors.cevapYontemi) {
        setErrors(prev => ({ ...prev, cevapYontemi: '' }));
      }
      
    } else if (name.startsWith('dogum')) {
      const datePart = name.split('dogum')[1].toLowerCase();
      let validatedValue;
      
      if (datePart === 'gun') {
        validatedValue = validateDatePart(value, 'day');
      } else if (datePart === 'ay') {
        validatedValue = validateDatePart(value, 'month');
      } else if (datePart === 'yil') {
        validatedValue = validateDatePart(value, 'year');
      }
      
      setFormData(prev => ({
        ...prev,
        dogumTarihi: {
          ...prev.dogumTarihi,
          [datePart]: validatedValue
        }
      }));
      
      if (errors.dogumTarihi) {
        setErrors(prev => ({ ...prev, dogumTarihi: '' }));
      }
      
    } else {
      let validatedValue = value;
      
      switch (name) {
        case 'tcKimlik':
          validatedValue = validateTcKimlik(value);
          break;
        case 'telefon':
          validatedValue = validatePhone(value);
          break;
        case 'ad':
        case 'soyad':
          validatedValue = validateName(value);
          break;
        case 'email':
          validatedValue = validateEmail(value);
          break;
        case 'il':
        case 'ilce':
          validatedValue = validateName(value);
          break;
        case 'disKapiNo':
        case 'icKapiNo':
          validatedValue = validateDoorNumber(value);
          break;
        case 'basvuruMetni':
          validatedValue = validateTextarea(value, 2000);
          break;
        default:
          break;
      }
      
      setFormData(prev => ({
        ...prev,
        [name]: validatedValue
      }));
    }
  };

  return (
    <div className="information-request-page">
      <div className="container">
        <div className="row">
          <QuickMenu />
          <div className="col-md-10">
            <h2>Bilgi Edinme Şahıs Başvurusu</h2>
            <div className="info-text">
              <p>
                4982 Sayılı Bilgi Edinme Hakkı Kanunu ve Bilgi Edinme Hakkı Kanununun Uygulanmasına İlişkin Esas ve Usuller Hakkında Yönetmelik'i çerçevesinde oluşturulmuştur. Bilgi ve belgeye erişim işlerini yürütmektedir.
              </p>
              <p>
                Belediyemiz web sitesinden veya bizzat başvuran herkes bu hizmetten yararlanabilir. E-posta yoluyla yapılan başvurularda T.C. Kimlik No kısmının doldurulması zorunludur. Telefonla başvuru kabul edilmemektedir.
              </p>
              <p>
                Vatandaşlarımızın bilgi edinme hakkı kapsamında, Bilgi Edinme Kanunu'nunda geçen, Madde 27- Tavsiye ve mütlalaa talepleri bu Kanun kapsamı dışındadır Kanun hükmünü göz önünde bulundurmaları gerekmektedir. Başvurular ilgili müdürlüklere online veya yazılı olarak bildirilir. İstisnalar hariç 15 iş günü içerisinde çözümlenen talebin sonucu ilgili müdürlük tarafından vatandaşa talep ettiği şekilde bilgi verilir.
              </p>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>T.C. Kimlik No* <small>(11 haneli)</small></label>
                <input
                  type="text"
                  name="tcKimlik"
                  required
                  value={formData.tcKimlik}
                  onChange={handleInputChange}
                  placeholder="12345678901"
                  maxLength={11}
                  className={errors.tcKimlik ? 'error' : ''}
                />
                {errors.tcKimlik && <small className="error-text">{errors.tcKimlik}</small>}
                {formData.tcKimlik && formData.tcKimlik.length !== 11 && !errors.tcKimlik && (
                  <small style={{color: '#ffc107'}}>T.C. Kimlik Numarası 11 haneli olmalıdır.</small>
                )}
              </div>

              <div className="form-group">
                <label>Doğum Tarihi*</label>
                <small>Gün.Ay.Yıl (Örnek: 29.05.1923) şeklinde doldurunuz</small>
                <div className="date-inputs">
                  <input
                    type="text"
                    placeholder="Gün"
                    name="dogumGun"
                    value={formData.dogumTarihi.gun}
                    onChange={handleInputChange}
                    required
                    maxLength={2}
                    className={errors.dogumTarihi ? 'error' : ''}
                  />
                  <input
                    type="text"
                    placeholder="Ay"
                    name="dogumAy"
                    value={formData.dogumTarihi.ay}
                    onChange={handleInputChange}
                    required
                    maxLength={2}
                    className={errors.dogumTarihi ? 'error' : ''}
                  />
                  <input
                    type="text"
                    placeholder="Yıl"
                    name="dogumYil"
                    value={formData.dogumTarihi.yil}
                    onChange={handleInputChange}
                    required
                    maxLength={4}
                    className={errors.dogumTarihi ? 'error' : ''}
                  />
                </div>
                {errors.dogumTarihi && <small className="error-text">{errors.dogumTarihi}</small>}
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Ad*</label>
                  <input
                    type="text"
                    name="ad"
                    required
                    value={formData.ad}
                    onChange={handleInputChange}
                    maxLength={50}
                    className={errors.ad ? 'error' : ''}
                  />
                  {errors.ad && <small className="error-text">{errors.ad}</small>}
                  <small className="char-count">{formData.ad.length}/50 karakter</small>
                </div>
                <div className="form-group">
                  <label>Soyad*</label>
                  <input
                    type="text"
                    name="soyad"
                    required
                    value={formData.soyad}
                    onChange={handleInputChange}
                    maxLength={50}
                    className={errors.soyad ? 'error' : ''}
                  />
                  {errors.soyad && <small className="error-text">{errors.soyad}</small>}
                  <small className="char-count">{formData.soyad.length}/50 karakter</small>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Cep Telefonu*</label>
                  <input
                    type="tel"
                    name="telefon"
                    required
                    value={formData.telefon}
                    onChange={handleInputChange}
                    placeholder="05321234567"
                    maxLength={11}
                    className={errors.telefon ? 'error' : ''}
                  />
                  {errors.telefon && <small className="error-text">{errors.telefon}</small>}
                  <small className="char-count">{formData.telefon.length}/11 karakter</small>
                </div>
                <div className="form-group">
                  <label>E-posta*</label>
                  <input
                    type="email"
                    name="email"
                    required
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="ornek@email.com"
                    maxLength={100}
                    className={errors.email ? 'error' : ''}
                  />
                  {errors.email && <small className="error-text">{errors.email}</small>}
                  <small className="char-count">{formData.email.length}/100 karakter</small>
                </div>
              </div>

              <div className="form-group">
                <label>Cevap Yöntemleri*</label>
                <div className="checkbox-group">
                  <label>
                    <input
                      type="checkbox"
                      name="cevapYontemi"
                      value="sms"
                      onChange={handleInputChange}
                      checked={formData.cevapYontemi.includes('sms')}
                    />
                    SMS
                  </label>
                  <label>
                    <input
                      type="checkbox"
                      name="cevapYontemi"
                      value="email"
                      onChange={handleInputChange}
                      checked={formData.cevapYontemi.includes('email')}
                    />
                    E-posta
                  </label>
                </div>
                {errors.cevapYontemi && <small className="error-text">{errors.cevapYontemi}</small>}
              </div>

              <div className="form-group">
                <label>Başvuru Tipi*</label>
                <select
                  name="basvuruTipi"
                  required
                  value={formData.basvuruTipi}
                  onChange={handleInputChange}
                  className={errors.basvuruTipi ? 'error' : ''}
                >
                  <option value="">Seçiniz</option>
                  <option value="genel">Genel Başvuru</option>
                  <option value="sikayet">Şikayet</option>
                  <option value="oneri">Öneri</option>
                </select>
                {errors.basvuruTipi && <small className="error-text">{errors.basvuruTipi}</small>}
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>İl</label>
                  <input
                    type="text"
                    name="il"
                    value={formData.il}
                    onChange={handleInputChange}
                    maxLength={50}
                  />
                  <small className="char-count">{formData.il.length}/50 karakter</small>
                </div>
                <div className="form-group">
                  <label>İlçe</label>
                  <input
                    type="text"
                    name="ilce"
                    value={formData.ilce}
                    onChange={handleInputChange}
                    maxLength={50}
                  />
                  <small className="char-count">{formData.ilce.length}/50 karakter</small>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Dış Kapı No</label>
                  <input
                    type="text"
                    name="disKapiNo"
                    value={formData.disKapiNo}
                    onChange={handleInputChange}
                    maxLength={10}
                  />
                  <small className="char-count">{formData.disKapiNo.length}/10 karakter</small>
                </div>
                <div className="form-group">
                  <label>İç Kapı No</label>
                  <input
                    type="text"
                    name="icKapiNo"
                    value={formData.icKapiNo}
                    onChange={handleInputChange}
                    maxLength={10}
                  />
                  <small className="char-count">{formData.icKapiNo.length}/10 karakter</small>
                </div>
              </div>

              <div className="form-group">
                <label>Dosya</label>
                <input
                  type="file"
                  name="dosya"
                  onChange={handleInputChange}
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                />
                <small>Kabul edilen dosya türleri: PDF, Word belgesi, resim dosyaları</small>
              </div>

              <div className="form-group">
                <label>Başvuru Metni* <small>({formData.basvuruMetni.length}/2000 karakter)</small></label>
                <textarea
                  name="basvuruMetni"
                  required
                  value={formData.basvuruMetni}
                  onChange={handleInputChange}
                  rows={4}
                  maxLength={2000}
                  className={errors.basvuruMetni ? 'error' : ''}
                />
                {errors.basvuruMetni && <small className="error-text">{errors.basvuruMetni}</small>}
              </div>

              <div className="form-actions">
                <button
                  type="submit"
                  className={`submit-button ${isSubmitting ? 'loading' : ''}`}
                  disabled={isSubmitting}
                  aria-busy={isSubmitting}
                  aria-live="polite"
                >
                  {isSubmitting ? <><span className="spinner" /> Gönderiliyor…</> : 'Başvuruyu Gönder'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <style jsx>{`
        .form-group {
          margin-bottom: 1.5rem;
          position: relative;
        }

        .form-group label {
          display: block;
          margin-bottom: 0.5rem;
          font-weight: 500;
        }

        .form-group label small {
          font-weight: normal;
          color: #6c757d;
          margin-left: 0.5rem;
        }

        .error {
          border-color: #dc3545 !important;
          box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
        }

        .error-text {
          color: #dc3545;
          font-size: 0.875rem;
          margin-top: 0.25rem;
          display: block;
        }

        .char-count {
          color: #6c757d;
          font-size: 0.75rem;
          display: block;
          margin-top: 0.25rem;
        }

        .form-row {
          display: flex;
          gap: 1rem;
        }

        .form-row .form-group {
          flex: 1;
        }

        .date-inputs {
          display: flex;
          gap: 0.5rem;
        }

        .date-inputs input {
          flex: 1;
        }

        .checkbox-group {
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
        }

        .checkbox-group label {
          display: flex;
          align-items: center;
          gap: 0.25rem;
          font-weight: normal;
        }

        input, select, textarea {
          width: 100%;
          padding: 0.75rem;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 1rem;
          transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        }

        input:focus, select:focus, textarea:focus {
          outline: none;
          border-color: #007bff;
          box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
        }

        .submit-button {
          background-color: #007bff;
          color: white;
          border: none;
          padding: 0.75rem 1.5rem;
          border-radius: 4px;
          font-size: 1rem;
          cursor: pointer;
          transition: background-color 0.15s ease-in-out;
        }

        .submit-button:hover {
          background-color: #0056b3;
        }
        .submit-button[disabled] {
          opacity: .7;
          cursor: not-allowed;
        }
        .spinner {
          display:inline-block;
          width:1em;height:1em;margin-right:.5em;
          border:2px solid currentColor;border-right-color:transparent;border-radius:50%;
          animation: spin .6s linear infinite; vertical-align:-0.125em;
        }
        @keyframes spin { to { transform: rotate(360deg); } }
        
        @media (max-width: 768px) {
          .form-row {
            flex-direction: column;
            gap: 0;
          }
          
          .date-inputs {
            flex-direction: column;
          }
          
          .checkbox-group {
            flex-direction: column;
            gap: 0.5rem;
          }
        }
      `}</style>
    </div>
  );
};

export default PersonalInformationRequest;